import styled from 'styled-components';

export const ContentWrapper = styled.div`
    background-color: white;
    overflow: scroll;
    margin: 150px 25px 50px 25px;
  padding: 15px;
`;
